import React, {type ReactElement} from "react";
import {useStaticQuery, graphql} from "gatsby";
import {LOCALE} from "/src/config";
import {visibleForLocale} from "/src/utils/utils";
import {MaybeType} from "/src/types";
import Footer from "./Footer";

interface FooterWrapperProps {
  newNavIsRenderedIn: MaybeType<Array<string>>;
  hideNav?: boolean;
  hidePrivacyPolicy?: boolean;
}

const FooterWrapper = (props: FooterWrapperProps): ReactElement | null => {
  const {newNavIsRenderedIn, hideNav, hidePrivacyPolicy} = props;

  const data = useStaticQuery(
    graphql`
      query FooterQuery {
        allContentfulSuperMainNavBars(
          filter: {
            contentful_id: {
              in: ["2CZli1ZOa8gYEfIwUvKEK8", "1fLo5OPXBM4tsJBipoVVOR"]
            }
            node_locale: {in: ["en-US", "zh-CN"]}
          }
        ) {
          nodes {
            contentful_id
            node_locale
            navTabs {
              ...NavTabLevelFragment
            }
          }
        }
      }
    `
  );

  if (!newNavIsRenderedIn || !visibleForLocale(newNavIsRenderedIn, LOCALE)) {
    return null;
  }

  const localizedNavBar = data.allContentfulSuperMainNavBars.nodes.find(
    (el: Record<string, string>) => {
      if (LOCALE === "en-US") {
        return (
          el.contentful_id === "2CZli1ZOa8gYEfIwUvKEK8" &&
          el.node_locale === "en-US"
        );
      } else if (LOCALE === "zh-CN") {
        return (
          el.contentful_id === "1fLo5OPXBM4tsJBipoVVOR" &&
          el.node_locale === LOCALE
        );
      }
      return false;
    }
  );

  const {navTabs} = localizedNavBar;

  return (
    <Footer
      hidePrivacyPolicy={hidePrivacyPolicy}
      hideNav={hideNav}
      navTabs={navTabs}
    />
  );
};

export default FooterWrapper;
